module.exports = __webpack_public_path__ + "media/images/icon-arrow-down-long-carnation-efda6f48a7283b903e61eb16b0eb412b.svg";